import React from "react";

import RedirectContainer from "@/components/business/RedirectContainer/RedirectContainer";

const RedirectPage = () => {
  return <RedirectContainer />;
};

export default RedirectPage;
